import Navbar from "@Components/navbar";
import { PlayIcon } from "@assets/index";
import styles from "./styles";
import {UploadIcon} from "@radix-ui/react-icons"
import AutomationTable from "./components/AutomationTable";
import { useCreateAutomationMutation, useDeleteAutomationMutation, useLazyGetAutomationsQuery } from "./apiSlice";
import { useEffect, useState } from "react";
import ReactModal from 'react-modal';
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@Constants/routes";


import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@Components/shadcn/ui/pagination"
import { displayToast } from "@Utils/toast";
import Loader from "@Components/Loader";


const AutomationList = () => {

  const [AutomationsData, setAutomationsData] = useState<any>({})
  
  const [getAutomation, { data: automationData, error: automationErr,isLoading: isAutomationLoading}] = useLazyGetAutomationsQuery()
  let [createNewAutomation, { data: createAutomationData, error: createAutomationError, isLoading: isCreateAutomationLoading }] = useCreateAutomationMutation()
  let [DeleteAutomation, { data: DeleteAutomationData, error: DeleteAutomationError, isLoading: isDeleteAutomationLoading }] = useDeleteAutomationMutation()

  const [editAutomationModal, setEditAutomationModal] = useState(false)
  const [EditAutomationModalData, setEditAutomationModalData] = useState({})
  const [deleteAutomationModal, setDeleteAutomationModal] = useState(false)
  const [DeleteAutomationModalData, setDeleteAutomationModalData] = useState(-1)
  const [pageLimit, setPageLimit] = useState(10)
  const [pageNumber, setPageNumber] = useState(1)
  const [DeleteAutomationId, setDeleteAutomationId] = useState(-1)

  const navigate = useNavigate();

  const closeEditAutomationModal = () => {
    setEditAutomationModal(!editAutomationModal)
  }

  const openEditAutomationModal = (contact_index: number) => {
    setEditAutomationModalData(automationData?.data[contact_index])
    setEditAutomationModal(!editAutomationModal)
  }


  const closeDeleteAutomationModal = () => {
    setDeleteAutomationModal(!DeleteAutomationModal)
  }

  const openDeleteAutomationModal = (automation_id:number) => {
    setDeleteAutomationId(automation_id)
    setDeleteAutomationModal(!editAutomationModal)
  }

  const deleteAutomationButtonClick = (e:any) => {
    DeleteAutomation(DeleteAutomationId)
    setDeleteAutomationModal(!DeleteAutomationModal)
  }

  useEffect(() => {
    document.title = "LinkPlease - Dashboard | Automation List";

    getAutomation({
      limit: pageLimit,
      page: pageNumber
    })
    
  }, [])


  useEffect(() => {
    if(automationData?.data?.automations) setAutomationsData(automationData);
    if(automationErr) console.error(automationErr);
  }, [automationData])
  
  

  useEffect(() => {
    getAutomation({
      limit: pageLimit,
      page: pageNumber
    })
  }, [pageLimit, pageNumber, DeleteAutomationData])

  useEffect(() => {
    if (DeleteAutomationData) {
      displayToast('success', DeleteAutomationData?.message || 'Automation Deleted Successful')
    }

    if (DeleteAutomationError) {
      console.error(DeleteAutomationError);
      displayToast('error', DeleteAutomationError?.data?.message || 'Automation Deletion Unsuccessful')
    }
  
  }, [DeleteAutomationData, DeleteAutomationError])
  

  const addAutomationButtonClick = (e:any) => {
    createNewAutomation({})
  }

  const handlePageLimitChange = (e: any) => {
    if (e?.target?.name == 'pageLimit') {
      setPageNumber(1)
      setPageLimit(e?.target?.value)
    }
  }

  const handlePageNumberChange = (type: number) => {
    
    if (type === -1) setPageNumber(pageNumber - 1)
    if (type === 1) setPageNumber(pageNumber + 1)
  }

  useEffect(() => {
    
    if (createAutomationData) {
      navigate(ROUTES.FLOW_BUILDER.replace(':automation_doc_id', createAutomationData?.data?.automation_id))
    }
  
    
  }, [createAutomationData, createAutomationError])

  const refreshAutomation = () => {
    getAutomation({
      limit: pageLimit,
      page: pageNumber
    })
  }
  


  return (
    <div style={styles.BACKGROUND}>
      {/* <Navbar /> */}
      <div className="border-b rounded-lg border-gray-200 sticky top-0">
        <div className="z-unset mx-auto px-2 md:px-4 py-3 md:h-16 flex flex-row md:items-center justify-between gap-3 md:gap-0">
          <div className="flex items-center gap-2">
            <h1 className="text-3xl font-medium">Automations</h1>
          </div>

          <div className="flex items-center justify-end w-full md:w-auto gap-2 md:gap-4">
            
          <button onClick={addAutomationButtonClick} style={styles.ADD_BUTTON} className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="size-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
            Create
          </button>
          </div>
        </div>
      </div>
      <div className="mt-[3rem]"> 
        {isAutomationLoading ? <Loader isLoading={true} /> : <AutomationTable data={AutomationsData?.data?.automations} openDeleteAutomationModal={openDeleteAutomationModal} fetchAutomations={refreshAutomation}/>}
      </div>
      {/* <EditAutomationModal isModalOpen={editAutomationModal} editAutomationModalOnClose={closeEditAutomationModal} /> */}
      <DeleteAutomationModal isModalOpen={deleteAutomationModal} editAutomationModalOnClose={closeDeleteAutomationModal} deleteAutomation={deleteAutomationButtonClick} deleteAutomationId={DeleteAutomationId}/>
      <div className="mt-3">
        <Pagination>
          <PaginationContent>
            {pageNumber == 1
            ? <></> :
              <PaginationItem onClick={(e) => handlePageNumberChange(-1)}>
              <PaginationPrevious />
            </PaginationItem>
            }

            <PaginationItem>
              <PaginationLink isActive>{pageNumber}</PaginationLink>
            </PaginationItem>

            { pageLimit*pageNumber < automationData?.totalCount  && 
              <PaginationItem onClick={(e) => handlePageNumberChange(1)}>
                <PaginationNext />
              </PaginationItem>
            }
          </PaginationContent>
          <div className="flex items-center ml-5">
            <label>Page length:</label>
            <select className="outline-none" name="pageLimit" onChange={handlePageLimitChange} value={pageLimit}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </Pagination>
      </div>
      

    </div>
  );
};

interface EditAutomationModalInterface {
  isModalOpen: boolean;
  editAutomationModalOnClose: () => void;
}


const EditAutomationModal = (props: EditAutomationModalInterface) => {

  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.editAutomationModalOnClose}
      style={
        { overlay: {}, content: styles.editContactModalContent }
      }
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false} >
      Hello World
      </ReactModal>
  )
}



interface DeleteAutomationModalInterface {
  isModalOpen: boolean;
  editAutomationModalOnClose: () => void;
  deleteAutomation: (e:any) => void;
  deleteAutomationId: number
}


const DeleteAutomationModal = (props: DeleteAutomationModalInterface) => {
  

  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.editAutomationModalOnClose}
      style={
        { overlay: {}, content: styles.deleteContactModalContent }
      }
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false} 
      >
      <>
        <div className="pb-[.5rem] border-b-2 border-slate-300" style={styles.modalHeader}>
          <h3>Confirm</h3>
        </div>
        <div className="py-[1rem]" style={styles.modalContent}>
          <p>Do you want to remove this automation?</p>
          <div className="flex justify-end mt-[2rem]">
            <button
            className="px-6 py-1 border-2 border-solid rounded border-green-500 mx-2"
            style={styles.greenButton}
              onClick={props.editAutomationModalOnClose}>
              Cancel
            </button>
            <button className="px-6 py-1 border-2 border-solid rounded" style={styles.redButton} onClick={props.deleteAutomation}>Delete</button>
          </div>
        </div>
      </>
    </ReactModal>
  )
}

export default AutomationList;
